import { GlobalState } from 'ha/types/store';
import { FetchStatus } from 'ha/types/FetchStatus';

import { STATE_NAME } from '../constants';

export const getListingsSupportedCountriesFetchStatus = (
  state: GlobalState,
): FetchStatus => state[STATE_NAME].supportedCountriesFetchStatus;

export const getListingsSupportedCurrenciesFetchStatus = (
  state: GlobalState,
): FetchStatus => state[STATE_NAME].supportedCurrenciesFetchStatus;

export const getListingsSupportedCountries = (state: GlobalState): string[] =>
  state[STATE_NAME].supportedCountries;

export const getListingsSupportedCurrencies = (state: GlobalState): string[] =>
  state[STATE_NAME].supportedCurrencies;
